import gql from 'graphql-tag';

export default gql`
  query allSchoolsSchoolMarket($districtId: ID = null, $schoolType: String = null) {
    allSchools(districtId: $districtId, schoolType: $schoolType) {
      id
      schoolId
      name
      address1
      address2
      city
      state
      zip
      county
      districtId
      type
      gradesServed
      applicationsSchoolMarket {
        createdAt
        submittedAt
        status
        isContinuation
        submittedBy
        term {
          id
          type
          year
        }
      }
      primaryPointOfContact {
        teamMemberId
        firstName
        lastName
        title
        phone
        email
        type
      }
      principal {
        teamMemberId
        firstName
        lastName
        title
        phone
        email
        type
      }
    }
  }
`;
